// @flow @format

export function encodeEmail(email: string): string {
	const [user, host] = email.split('@');
	if (!host) {
		return encodeURIComponent(user);
	}
	return `${encodeURIComponent(user)}@${host}`;
}



// WEBPACK FOOTER //
// ./src/lib/cloner-api/util.js